/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum UserQuizStatusEnum {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum QuestionTypeEnum {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}

export enum AnswerResultEnum {
  CORRECT = 'CORRECT',
  PARTIALLY = 'PARTIALLY',
  INCORRECT = 'INCORRECT',
}

export enum CompletionResultStatusEnum {
  SUCCEEDED = 'SUCCEEDED',
  FULL_SUCCEEDED = 'FULL_SUCCEEDED',
  PARTIALLY_SUCCEEDED = 'PARTIALLY_SUCCEEDED',
  NOT_SUCCEEDED = 'NOT_SUCCEEDED',
}
